import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'size' })
export class SizePipe implements PipeTransform {
    transform(value: number): string {
        if (!value) return '';
        if (value === 0) {
            return '0 B';
        }

        const sizes: string[] = ['B', 'KB', 'MB', 'GB', 'TB'];
        const k: number = 1024;
        const i: number = Math.floor(Math.log(value) / Math.log(k));

        return parseFloat((value / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }
}